import {
    tee3CallDevice,
    tee3closeCameraAndPubVideo,
    tee3getAccessToken,
    tee3getBrowserDetect,
    tee3getPlayers,
    tee3getRoom,
    tee3getSelfUser,
    tee3init,
    tee3join,
    tee3kick,
    tee3LeaveRoom,
    tee3OpenScreenAndPub,
    tee3StartLive,
    tee3StopLive
} from "./tee3";
import {isEmpty} from "../utils"
import {Message} from 'element-ui'

export const fullVideoMixin = {
    data(){
        return {
            videos:[],
            audios:[],
            interVal:null,
            pulished:true
        }
    },
    created(){
        bus.$on('onGetAccessToken', this.tee3enterRoom);// 获取token的回调函数
        bus.$on('initSuccess', this.tee3initSuccess);// 初始化成功的回调函数
        bus.$on('joinSuccess', this.tee3joinSuccess);// 加入房间的回调函数
        bus.$on('onSubscribleCameraResult', this.onSubscribleCameraResult);
        bus.$on('onSubscribleScreenResult', this.onSubscribleScreenResult);
        bus.$on('onSubscribleMicrophoneResult', this.onSubscribleMicrophoneResult);
        bus.$on('onUserLeaveNotify', this.onUserLeaveNotify)
        bus.$on('unScreenResult',this.findUserVideo);
        bus.$on('shareScreen',this.shareScreen)
        // bus.$on('onMicrophoneStatusNotify',this.onMicrophoneStatusNotify);
        // bus.$on('onCameraStatusNotify',this.onCameraStatusNotify);
        // bus.$on('onLeaveIndication',this.onLeaveIndication);
        // bus.$on('onPublishCameraNotify',this.onPublishCameraNotify);
        // bus.$on('unpublish_camera_notify',this.unpublish_camera_notify);

    },
    beforeDestroy() {
        bus.$off('onGetAccessToken', this.tee3enterRoom);
        bus.$off('initSuccess', this.tee3initSuccess);
        bus.$off('joinSuccess', this.tee3joinSuccess);
        bus.$off('unScreenResult',this.findUserVideo);
    },
    computed: {
        joinInfo() {
            const {docInfo} = this;
            console.log(docInfo)
            return docInfo;
        }
    },
    methods:{
        //进入房间 判断是否有token
        tee3enterRoom(accessToken) {
            if (!accessToken) {
                tee3getAccessToken();
            } else {
                tee3init(accessToken, '2');
            }
        },
        //3t 初始化成功
        tee3initSuccess() {
            const {joinInfo, query} = this;
            tee3join(query.room + '', joinInfo.id || 'testid', joinInfo.docName || 'testname');
        },
        //3t 加入房间成功
        tee3joinSuccess(){
            const room = tee3getRoom(); // 获取房间对象
            const users = room.getParticipants();// 获取参会者列表
            Log('room', room);
            this.handlerUsers(users);
        },
        //处理用户数据
        handlerUsers(users) {
            const room = tee3getRoom();
            const selfUser = room.selfUser;
            users.forEach(user => {
                if (user.id === selfUser.id) {
                    //发布本地摄像头
                    this.publish(user);
                }
            });
        },
        publish(user){
            const room = tee3getRoom();
            const selfUser = room.selfUser;
            if (!user) user = selfUser;
            const {joinInfo} = this;
            //对象下的视频数组
            Log('videos', user.videos);
            //视频处理
            user.videos && user.videos.forEach(r => {
                this.updateVideo({
                    video:r,
                    userId:joinInfo.id,
                    userName:joinInfo.docName,
                    deviceName:r.name,
                    deviceId:r.id,
                    type:'local-video',
                    bigScreen:true,
                    screenFlag:false,
                    screenStream:null
                })
            })
            //声音处理
            if (user.audio && user.audio.id) {
                let audio = selfUser.getAudio(user.audio.id);
                audio.openMicrophone().then(() => {
                    Log('打开麦克风成功');
                    this.updateAudio({
                        userId: joinInfo.id,
                        userName: joinInfo.docName,
                        type: 'local-audio',
                        audio: true,
                    })
                }).otherwise((error) => {
                    console.error('openMicrophone error', error)
                });
            }
        },
        /**
         * 增加/更新audios
         * @param audio
         */
        updateAudio(audio) {
            const id = audio.userId || ""
            let idx ;
            idx = this.audios.findIndex(r =>  r.userName === audio.userName && r.userId === id);
            if (idx >= 0) {//更新
                this.audios.splice(idx, 1, {...this.audios[idx], ...audio});
            } else {//增加
                this.audios.push(audio);
            }
        },
        /**
         * 增加/更新videos
         * @param video
         */
        updateVideo(video) {
            //开始更新数组对象
            const id = video.deviceId || ""
            let idx ;
            if(video.screenFlag){
                idx = this.videos.findIndex(r => r.userName === video.userName && r.userId === video.userId);
            }else{
                idx = this.videos.findIndex(r => r.deviceId === id  && r.userName === video.userName && r.userId === video.userId);
            }
            if (idx >= 0) {//更新
                this.videos.splice(idx, 1, {...this.videos[idx], ...video});
            } else {//增加
                this.videos.push(video);
            }
        },
        onSubscribleCameraResult(stream, userId, userName, cameraId) {
            Log('接收到新的视频流',stream, userId, userName, cameraId)
            let type = 'video';
            this.updateVideo({
                type,
                stream,
                userId,
                userName,
                deviceId:cameraId
            });
        },
        onSubscribleScreenResult(stream, userId, userName, screenId) {
            Log('接收到新的桌面流',stream, userId, userName, screenId)
            this.updateVideo({
                screenStream:stream,
                userId,
                userName,
                screenId,
                type:'video',
                screenFlag:true
            })
        },
        onSubscribleMicrophoneResult(stream, userId, userName) {
            let type = 'audio';
            this.updateAudio({
                audioStream: stream, userId, userName, type
            });
        },
        onUserLeaveNotify(opt, reason, user) {
            let idx = this.videos.findIndex(r => r.userId === user.id);
            this.videos.splice(idx, 1);
        },
        gettee3getPlayers(){
            return tee3getPlayers()
        },
        gettee3getSelfUser(){
            return tee3getSelfUser()
        },
        openScreenAndPub(local) {
            const room = tee3getRoom();
            if (isEmpty(room)) return Message.error('还未进入房间');
            return tee3OpenScreenAndPub(local);//分享桌面
        },
        /**
         * 轮询查看屏幕共享是否关闭
         */
        checkScreenOutSelfUser(local) {
            this.interVal = setInterval(() => {
                if (this.getScreenState() == '1') {
                    this.previewVideo(local);
                }
            }, 5000)
        },
        getScreenState() {
            let selfUser = tee3getSelfUser();
            return selfUser.screen.status
        },
        previewVideo(local) {
            let selfUser = tee3getSelfUser();
            let videos = selfUser.videos;
            console.log(videos);
            videos.forEach((v) => {
                const video = selfUser.getVideo(v.id);
                video.preview(local).otherwise((error) => {
                    console.error('publish error', error)
                });
            })
            clearInterval(this.interVal);
        },
        findUserVideo(arg){
            let screenObj = arg[0];
            screenObj.unsubscrible();
            console.log('取消桌面共享')
            console.log(screenObj)
            let idx = this.videos.findIndex(r => r.userId === screenObj.ownerId && r.screenFlag);
            this.videos.splice(idx, 1, {...this.videos[idx], screenFlag:false});
        },
        findVideo(id, type) {
            let idx = this.videos.findIndex(r => r.userId === id && r.type === type);
            if (idx >= 0) {
                if(this.videos[idx].screen){
                    this.videos[idx].screen = false
                }
                return this.videos[idx]
            }
        },
        remotecmdCloseMicrophone(userId){
            const room = tee3getRoom();
            room.selfUser.remotecmdCloseMicrophone(userId);
        },
        remotecmdOpenMicrophone(userId){
            const room = tee3getRoom();
            room.selfUser.remotecmdOpenMicrophone(userId);
        },
        remotekickoffUser(userId){
            const room = tee3getRoom();
            room.kickoffUser(1,userId);
        },
        onMicrophoneStatusNotify(){
            let list = this.gettee3getPlayers() || [];//获取参会者列表数据
            this.$refs['memberList'].setList(list);
        },
        onCameraStatusNotify(status, cameraId, cameraName, userId){
            let list = this.gettee3getPlayers() || [];//获取参会者列表数据
            this.$refs['memberList'].setList(list);
            //本机摄像头状态被人强制修改 所以取消发布流
            if(userId == this.doc.id){
                console.log(status);
                console.log(StreamStatus.published);
                console.log('本人')
                if(status == StreamStatus.published){
                    //this.pulished = true;
                    this.$nextTick(() => {
                        this.$refs[userId][0].init();
                    })
                }else{
                    // this.pulished = false;
                }
            }
        },
        remotecmdPublishCamera(cameraId,userId){
            const room = tee3getRoom();
            const user = room.getUser(userId);
            const video = user.getVideo(cameraId);
            // if(! video.resolution){
            //     video.setResolution(resolutionSelect.value,resolutionSetTypeSelect.value);
            // }
            // if(! video.frameRate){
            //     video.setFrameRate(frameRateSelect.value);
            // }
            room.selfUser.remotecmdPublishCamera(video);
        },
        remotecmdUnpublishCamera(videoId){
            const room = tee3getRoom();
            room.selfUser.remotecmdUnpublishCamera(videoId);
        },
        onLeaveIndication(reason,userId){
            const room = tee3getRoom();
            const name = room.getUser(userId).name;
            this.$alert(`您被${name}踢出了会议室。`, '通知', {
                confirmButtonText: '确定',
                callback: () => {
                    this.$router.back();
                }
            });
        },
        onPublishCameraNotify(video){

        },
        //取消订阅
        unpublish_camera_notify(video){
            video.unsubscrible();
        },
        closeMyVideo(){
            const room = tee3getRoom();
            let self = room.selfUser;
            let videos = room.selfUser.videos;
            let index = 0;
            console.log('关闭前')
            console.log(videos)
            videos.forEach( rrr => {
                let video = self.getVideo(rrr.id);
                video.unpreview();
                video.unpublish();
                index++;
            })
            if (index === videos.length) {
                Log('本地所有设备关闭成功');
                console.log(room.selfUser.videos)
                window.t3VideoState = false
                console.log('关闭后')
                console.log(room.selfUser.videos)
            }
        },
        //分享屏幕
        shareScreen(local){
            this.openScreenAndPub(local);
            setTimeout(()=>{
                this.checkScreenOutSelfUser(local);
            },5000)
        },
        remoteCloseAudio(userId){
            this.remotecmdCloseMicrophone(userId);
        },
        openCloseAudio(userId){
            this.remotecmdOpenMicrophone(userId)
        },
        outMember(userId){
            this.remotekickoffUser(userId);
        },
        videoOpen(user){
            this.remotecmdPublishCamera(user.videos[0].id,user.id)
        },
        videoClose(user){
            this.remotecmdUnpublishCamera(user.videos[0].id)
        },
        openMe(user){
            //this.pulished = true;
            this.$nextTick( () => {
                this.$refs[user.id][0].init();
            })
        },
        audioOpenMe(user){
            const room = tee3getRoom();
            let id = user.audio.id;
            let audio = room.selfUser.getAudio(id);
            audio.openMicrophone().otherwise((error) => {
                Log('打开麦克风失败',error)
            });
        },
        closeAudioMe(user){
            const room = tee3getRoom();
            let id = user.audio.id;
            let audio = room.selfUser.getAudio(id);
            audio.closeMicrophone();
        },
        async LeaveRoom_(){
            const room = tee3getRoom();
            if(isEmpty(room)){
                Message.error('您还未进入房间')
                return
            }
            await tee3LeaveRoom();
        }
    }




}